import { FanCheckInInfo } from "../../models/fanCheckInInfo";
import { useTranslation } from "react-i18next";
import { MembershipCell } from "./membershipCell";
import { MemoCell } from "./memoCell";
import { CheckInDetail } from "../../models/checkInDetail";
import { ApplyConditionType } from "../../models/enum/applyCondition";
import { twclsx } from "../../utils/cssUtil";
import { SubscriptionCell } from "./subscriptionCell";

interface FanInfoTableProps {
  fanInfo?: FanCheckInInfo | null;
  eventDetail?: CheckInDetail | null;
}

export function FanInfoTable({ fanInfo, eventDetail }: FanInfoTableProps) {
  const { t } = useTranslation();

  const showBirthday = !!fanInfo?.applicantInputValue.birthDate;
  const showPhone = !!fanInfo?.applicantInputValue.phone;
  const showName =
    !(
      eventDetail?.applyConditions[ApplyConditionType.OFFICIAL_MEMBERSHIP]
        .length === 0
    ) && fanInfo?.applicantInputValue.name;
  const showCommonCell = showBirthday || showPhone || showName;
  const interMember = fanInfo?.fan.email.endsWith("@weversecompany.com");

  return (
    <>
      <table className={"table"}>
        <thead>
          <tr>
            <th colSpan={2}>{t("userdetail_account_subtitle")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>
              <div className={"flex items-center"}>
                {t("userdetail_account_email")}
                <p className={twclsx(interMember && "wev-icon-sm")}></p>
              </div>
            </th>
            <td className={twclsx(interMember && "text-primary")}>
              {fanInfo?.fan.email}
            </td>
          </tr>
        </tbody>
        {showCommonCell && (
          <>
            <thead>
              <tr>
                <th colSpan={2}>{t("userdetail_common_subtitle")}</th>
              </tr>
            </thead>
            <tbody>
              {showBirthday && (
                <tr>
                  <th>{t("userdetail_common_bday")}</th>
                  <td>
                    {fanInfo?.applicantInputValue.birthDate?.format(
                      t("date2_format"),
                    )}
                  </td>
                </tr>
              )}
              {showPhone && (
                <tr>
                  <th>{t("userdetail_common_phone")}</th>
                  <td>{fanInfo?.applicantInputValue.phone?.phoneNumber}</td>
                </tr>
              )}
              {showName && (
                <tr>
                  <th>{t("userdetail_m_name")}</th>
                  <td>
                    {t(
                      fanInfo?.applicantInputValue.name?.middleName
                        ? "name_full_format"
                        : "name_format",
                      {
                        first: fanInfo?.applicantInputValue.name?.firstName,
                        middle: fanInfo?.applicantInputValue.name?.middleName,
                        last: fanInfo?.applicantInputValue.name?.lastName,
                      },
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </>
        )}
        {fanInfo?.officialMemberships?.map((membership) => (
          <MembershipCell key={membership.region} membership={membership} />
        ))}
        {fanInfo?.subscriptions && (
          <SubscriptionCell
            key={fanInfo.subscriptions.type}
            subscription={fanInfo.subscriptions}
          />
        )}

        <MemoCell
          title={t("userdetail_attendantmemo_subtitle")}
          memo={fanInfo?.winner.memo}
        />
        <MemoCell
          title={t("userdetail_damemo_subtitle")}
          memo={fanInfo?.penalty.disadvantages?.at(0)?.memo}
        />
      </table>
    </>
  );
}
